import { useSyncExternalStore } from 'react';

import { isDarkThemeName, useTheme } from '#style/theme';

const OSCURO = '(prefers-color-scheme: dark)';

function suscribir(aviso: () => void) {
  const mq = window.matchMedia?.(OSCURO);
  mq?.addEventListener('change', aviso);
  return () => mq?.removeEventListener('change', aviso);
}

function sistemaOscuro() {
  return !!window.matchMedia?.(OSCURO).matches;
}

/**
 * La escena de la botella va de noche (luna y faro encendido) con el tema
 * oscuro y de día con el claro; con «automático», como el sistema.
 */
export function useNoche(): boolean {
  const [tema] = useTheme();
  const oscuroSistema = useSyncExternalStore(suscribir, sistemaOscuro);
  return tema === 'auto' ? oscuroSistema : isDarkThemeName(tema);
}
